import {createStore} from 'vuex';
import {searchStore} from './search-store';
import { advertStore } from './advert-store';
import { videoUploadingStore } from './video-uploading-store';

const emptyInfoModal = {
    active: false,
    title: null,
    message: null,
    trackAction: null,
    trackCategory: null,
    modalId: null,
};

const sharedStore = {
    state: {
        loginModalOpened: false,
        modalsCount: 0,
        engagesCount: 0,
        activeInputCount: 0,
        infoModal: emptyInfoModal,
        fullscreenModalSrc: null,
        fullscreenModalUrl: null,
        unreadMessagesCount: 0,
        chatOpened: false,
        contactFormOpened: false,
        preventShowingModals: false,
        hidePreviewChatIcon: false,
        commentRegistrationPlace: '',
        messageRegistrationPlace: '',
        rateRegistrationPlace: '',
        preselectedRegistrationPlace: '',
    },
    mutations: {
        openLoginModal(state) {
            state.loginModalOpened = true;
        },
        closeLoginModal(state) {
            state.loginModalOpened = false;
        },
        incrementModalsCount(state) {
            state.modalsCount++;
        },
        decrementModalsCount(state) {
            state.modalsCount--;
        },
        incrementEngagesCount(state) {
            state.engagesCount++;
        },
        decrementEngagesCount(state) {
            state.engagesCount--;
        },
        incrementActiveInputCount(state) {
            state.activeInputCount++;
        },
        decrementActiveInputCount(state) {
            state.activeInputCount--;
        },
        openInfoModal(state, infoModal) {
            state.infoModal = infoModal;
        },
        closeInfoModal(state) {
            state.infoModal = emptyInfoModal;
        },
        loginModeSwitch() {

        },
        openChat(state) {
            state.chatOpened = true;
        },
        closeChat(state) {
            state.chatOpened = false;
        },
        preventShowModals(state, src) {
            state.preventShowingModals = src;
        },
        openFeedback() {

        },
        openConversation() {

        },
        openRegionalSettings() {

        },
        openRegionSelectModal() {

        },
        openReportModal() {

        },
        openLimitInfoModal() {

        },
        submitReportModal() {

        },
        openFullscreenModal(state, src) {
            state.fullscreenModalSrc = src;
        },
        closeFullscreenModal(state) {
            state.fullscreenModalSrc = null;
            state.fullscreenModalData = null;
        },
        openPreviewFullscreenModal(state, payload) {
            const {src, url} = payload;
            state.fullscreenModalData = {
                isCompactActionsMode: false,
                currentPage: location.pathname + location.search + location.hash,
                title: document.title,
                switchCompactActionsMode(val) {
                    this.isCompactActionsMode = val;
                },
                shouldReplaceHistory: true,
            };
            state.fullscreenModalSrc = src;
            state.fullscreenModalUrl = url;
        },
        openPreview() {
        },
        openChatPreview() {
        },
        openBoostModal() {
        },
        setUnreadMessagesCount(state, unreadMessagesCount) {
            state.unreadMessagesCount = unreadMessagesCount;
        },
        autocompleteCallback(state, src) {
            state.autocompleteResult = src;
        },
        changeLogoVisibility(state, src) {
            state.logoVisibility = src;
        },
        closeDropdown(state, payload) {
            if (payload === state.openedDropdown) {
                state.openedDropdown = null;
            }
        },
        openDropdown(state, payload) {
            state.openedDropdown = payload;
        },
        preventShowingEngage(state, payload) {
            state.preventedEngage = payload;
        },
        timerTimeout(state, timerEvent) {

        },
        filterDeepUpdate(state, filter) {

        },
        commentsCount(state, commentsCount) {

        },
        markAsViewed(advertId) {
        },
        hidePreviewChatIcon(state, payload) {
            state.hidePreviewChatIcon = payload;
        },

        changePreselectRegistrationReason(state, payload) {
            state.preselectedRegistrationPlace = payload;
        },

        registerAdvertWizard(state, payload) {

        },

        loginAdvertWizard(state, payload) {

        },

        showFeedbackButton(state) {
        },

        hideFeedbackButton(state) {
        },
    },
};

const store = createStore({
    modules: {
        search: searchStore,
        shared: sharedStore,
        advert: advertStore,
        videoUploading: videoUploadingStore
    },
});

const initVuex = (app) => {
    app.use(store);
};

export {
    initVuex,
    store,
};
